<div class="container">
  <div class="top-bar">
    <div class="title">{{ 'sign_up_2' | translate }}</div>
    <div class="close">
      <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()"> </cs-icon-button>
    </div>
  </div>
  <div class="content">
    <div class="text">{{ 'please_confirm_the_following_to_create_your_account_in_brand' | translate }}</div>

    <div class="check">
      <input type="checkbox" name="check-old" id="check-old" [(ngModel)]="checkedOld" />
      <label for="check-old">{{ 'i_am_at_least_18_years_old' | translate }}</label>
    </div>

    <div class="check">
      <input type="checkbox" name="check-terms" id="check-terms" [(ngModel)]="checkedTerms" />
      <div class="check-text">
        <label for="check-terms">{{ 'i_accept_the' | translate }}</label>
        <span class="link" (click)="jumpToAgree($event)"> {{ 'terms_and_conditions_2' | translate }} </span>
        <span>{{ 'and_the' | translate }}</span>
        <span class="link" (click)="jumpToPolicy($event)"> {{ 'privacy_policy' | translate }} </span>
      </div>
    </div>

    <cs-button
      class="submit"
      size="large"
      [label]="'continue' | translate"
      [disabled]="!checkedOld || !checkedTerms"
      (buttonClick)="submit()"
    ></cs-button>
  </div>
</div>
